module.exports = __webpack_public_path__ + "img/bg_4.cfefffc5.png";